import React from "react";

/**
 * Renders an SVG icon for an invited user.
 *
 * @return {JSX.Element} SVG icon component
 */
export const InvitedIcon = ({ cls }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      className={cls}
    >
      <path
        d="M23.5016 16.5C19.6402 16.5 16.5 19.6402 16.5 23.5016C16.5 27.363 19.6402 30.5032 23.5016 30.5032C27.363 30.5032 30.5032 27.363 30.5032 23.5016C30.5032 19.6402 27.363 16.5 23.5016 16.5ZM27.0024 26.5858V26.419C27.0024 25.4527 26.2182 24.6686 25.252 24.6686H21.7512C20.785 24.6686 20.0008 25.4527 20.0008 26.419V26.5858C19.275 25.7631 18.8339 24.6826 18.8339 23.5016C18.8339 20.9274 20.9273 18.8339 23.5016 18.8339C26.0758 18.8339 28.1693 20.9274 28.1693 23.5016C28.1693 24.6826 27.7282 25.762 27.0024 26.5858ZM25.252 21.7512C25.252 22.7174 24.4678 23.5016 23.5016 23.5016C22.5354 23.5016 21.7512 22.7174 21.7512 21.7512C21.7512 20.785 22.5354 20.0008 23.5016 20.0008C24.4678 20.0008 25.252 20.785 25.252 21.7512ZM24.6685 4.83069H23.5016V3.66376C23.5016 3.01961 22.9788 2.49683 22.3347 2.49683C21.6905 2.49683 21.1677 3.01961 21.1677 3.66376V4.83069H11.8323V3.66376C11.8323 3.01961 11.3095 2.49683 10.6653 2.49683C10.0212 2.49683 9.4984 3.01961 9.4984 3.66376V4.83069H8.33146C5.11423 4.83069 2.4968 7.44812 2.4968 10.6654V24.6686C2.4968 27.8858 5.11423 30.5032 8.33146 30.5032H14.1661C14.8103 30.5032 15.3331 29.9804 15.3331 29.3363C15.3331 28.6921 14.8103 28.1694 14.1661 28.1694H8.33146C6.40135 28.1694 4.83066 26.5987 4.83066 24.6686V14.1662H28.1693C28.1693 14.8103 28.6921 15.3331 29.3363 15.3331C29.9804 15.3331 30.5032 14.8103 30.5032 14.1662V10.6654C30.5032 7.44812 27.8858 4.83069 24.6685 4.83069ZM4.83066 11.8323V10.6654C4.83066 8.73525 6.40135 7.16456 8.33146 7.16456H24.6685C26.5986 7.16456 28.1693 8.73525 28.1693 10.6654V11.8323H4.83066Z"
        fill="currentColor"
      />
    </svg>
  );
};
